<script setup lang="ts">
/**
 * UI-kit component
 * Category: Badges
 * Name: BadgeActivityStatus
 */
import type { BadgeActivityStatusProps } from '../types/interfaces'

import { useBadgeActivityStatus } from '../composables/use-badge-activity-status.hook'
import { AppBadge } from '../../app-badge'

defineOptions({
  name: 'BadgeActivityStatus',
})

const props = defineProps<BadgeActivityStatusProps>()

const {
  color,
  text,
} = useBadgeActivityStatus({ props })
</script>

<template>
  <AppBadge
    :color="color"
    :text="text"
  />
</template>
